"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var COMMUNITY_POPUP_URL = "https://apps.wix.com/members-area/public/modal/join-community";
var BARE = "BARE";

var WixCodeApiManager = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(wixCodeApi, appParams, compId) {
    var _wixCodeApi, _appParams, _compId, currentMember, token, signedInstance, instanceId, instanceParams, biToken, appInstanceId, wixUser, wixWindow, currentUser, currentUserId, isLoggedIn, privateUserFlag, data;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _wixCodeApi = wixCodeApi;
            _appParams = appParams;
            _compId = compId;
            currentMember = null;
            token = null;
            signedInstance = appParams.instance;
            instanceId = appParams.instanceId;
            instanceParams = appParams && JSON.parse(atob(appParams.instance.substring(appParams.instance.indexOf(".") + 1, appParams.instance.length)));
            biToken = instanceParams && instanceParams.biToken;
            appInstanceId = appParams && appParams.appInstanceId;
            wixUser = wixCodeApi.user;
            wixWindow = wixCodeApi.window;
            currentUser = wixUser.currentUser;
            currentUserId = wixUser.currentUser.id;
            isLoggedIn = currentUser.loggedIn;
            privateUserFlag = isLoggedIn ? currentUser.profilePrivacyStatus === "PRIVATE" : false;
            _context2.next = 18;
            return getContextToken(currentUser.instance, instanceId, currentUserId);

          case 18:
            data = _context2.sent;

            if (data) {
              currentMember = data.currentUser ? data.currentUser.member : null;
              token = data.token ? data.token.componentContext : null;
            }

            return _context2.abrupt("return", {
              navigateToProfile: function navigateToProfile(id) {
                wixCodeApi.site.getPublicAPI('14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9').then(function (api) {
                  api.navigateToMember({
                    memberId: id
                  })["catch"](console.error);
                });
              },
              requestLogin: function requestLogin() {
                wixUser.promptLogin();
              },
              showJoinCommunityPopup: function showJoinCommunityPopup() {
                var onClose = function onClose(_ref2) {
                  var message = _ref2.message;
                  currentUser.profilePrivacyStatus = "PUBLIC";
                  privateUserFlag = currentUser.profilePrivacyStatus;
                };

                wixWindow.getBoundingRect().then(function (windowSizeInfo) {
                  wixWindow.openModal(COMMUNITY_POPUP_URL, {
                    height: windowSizeInfo.window.height,
                    width: windowSizeInfo.window.width,
                    theme: BARE
                  }, compId).then(onClose);
                });
              },
              authConfig: {
                isLoggedIn: isLoggedIn,
                privateUserFlag: privateUserFlag
              },
              updateCID: function () {
                var _updateCID = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(id) {
                  var data;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return getContextToken(signedInstance, instanceId, id);

                        case 2:
                          data = _context.sent;

                          if (!data) {
                            _context.next = 7;
                            break;
                          }

                          currentMember = data.currentUser ? data.currentUser.member : null;
                          token = data.token ? data.token.componentContext : null;
                          return _context.abrupt("return", token);

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                function updateCID(_x4) {
                  return _updateCID.apply(this, arguments);
                }

                return updateCID;
              }(),
              data: {
                token: token,
                currentMember: currentMember
              },
              biEventsParams: {
                compId: compId,
                biToken: biToken,
                currentUserId: currentUserId,
                appInstanceId: appInstanceId,
                instanceId: instanceId
              }
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function WixCodeApiManager(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

function getContextToken(_x5, _x6, _x7) {
  return _getContextToken.apply(this, arguments);
}

function _getContextToken() {
  _getContextToken = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(signedInstance, containerId, uid) {
    var reqUrl, res, data;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            reqUrl = "https://wixlabs-comments-dev.appspot.com/api/data/token?signedInstance=" + signedInstance + "&containerId=" + containerId + "&uid=" + uid; //let reqUrl = `http://localhost:3500/api/data/token?signedInstance=${signedInstance}&containerId=${containerId}&uid=${uid}`;

            _context3.next = 4;
            return fetch(reqUrl);

          case 4:
            res = _context3.sent;
            _context3.next = 7;
            return res.json();

          case 7:
            data = _context3.sent;
            return _context3.abrupt("return", data);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            console.log("error fetching token", _context3.t0);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 11]]);
  }));
  return _getContextToken.apply(this, arguments);
}

var _default = WixCodeApiManager;
exports["default"] = _default;